/* eslint-disable max-len */
import 'react';

const CheckedSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor" {...props} >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g>
                <rect fill="currentColor" opacity="0" x="0" y="0" width="24" height="24"></rect>
                <path d="M19.7726719,1.24883919 C20.4084405,0.484602252 21.5433692,0.380458051 22.3076061,1.01622661 C23.002367,1.59419803 23.1515966,2.58469848 22.6953252,3.33419538 L22.5402187,3.55116081 L9.27913472,19.4918835 C8.60198497,20.3058634 7.39091119,20.3513441 6.65237279,19.643204 L6.47816512,19.4504771 L0.982803794,12.4327037 C0.369903342,11.6500078 0.507549709,10.5186535 1.29024556,9.90575301 C2.00178724,9.34857078 3.00147644,9.41167518 3.63783878,10.0158045 L3.81719621,10.2131948 L7.9368,15.4752 L19.7726719,1.24883919 Z" fill="currentColor" fillRule="nonzero"></path>
            </g>
        </g>
    </svg>
);
export default CheckedSvg;
